import { Directive, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';

@Directive({
	// tslint:disable-next-line:directive-selector
	selector: '[ifDesktop]',
	standalone: true
})
export class IfDesktopDirective {
	private templateRef = inject<TemplateRef<any>>(TemplateRef);
	private viewContainerRef = inject(ViewContainerRef);

	constructor() {
		const breakpointObserver = inject(BreakpointObserver);

		this.viewContainerRef.clear();

		breakpointObserver.observe('(min-width: 600px)').subscribe((result) => {
			this.viewContainerRef.clear();
			if (result.matches) {
				this.viewContainerRef.createEmbeddedView(this.templateRef);
			}
		});
	}
}
